import Vue from 'vue'

const KEY = 'rds_favorites'

export const favoritesState = Vue.observable({
  routes: JSON.parse(localStorage.getItem(KEY) || '[]'),
})

export function isFavorite(route) {
  return favoritesState.routes.includes(route)
}

export function toggleFavorite(route) {
  const idx = favoritesState.routes.indexOf(route)
  if (idx !== -1) {
    favoritesState.routes.splice(idx, 1)
  } else {
    favoritesState.routes.push(route)
  }
  localStorage.setItem(KEY, JSON.stringify(favoritesState.routes))
}
